import WidgetModule from "@eisinc/Overrides/Widgets/RequestRma/RequestRmaNotes";

export * from "@eisinc/Overrides/Widgets/RequestRma/RequestRmaNotes";

export default WidgetModule;
